import { useEffect, useState } from 'react';

interface ResponsiveState {
	isMobile: boolean;
	isMobilePortrait: boolean;
	isMobileLandscape: boolean;
	isTablet: boolean;
	isTabletPortrait: boolean;
	isTabletLandscape: boolean;
	isDesktop: boolean;
	isPortrait: boolean;
	isLandscape: boolean;
	width: number;
	height: number;
}

export default function useResponsive(): ResponsiveState {
	const [state, setState] = useState<ResponsiveState>({
		isMobile: window.innerWidth < 768,
		isMobilePortrait: window.innerWidth < 768 && window.innerHeight > window.innerWidth,
		isMobileLandscape: window.innerWidth < 768 && window.innerWidth > window.innerHeight,
		isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
		isTabletPortrait:
			window.innerWidth >= 768 && window.innerWidth < 1024 && window.innerHeight > window.innerWidth,
		isTabletLandscape:
			window.innerWidth >= 768 && window.innerWidth < 1024 && window.innerWidth > window.innerHeight,
		isDesktop: window.innerWidth >= 1024,
		isPortrait: window.innerHeight > window.innerWidth,
		isLandscape: window.innerWidth > window.innerHeight,
		width: window.innerWidth,
		height: window.innerHeight,
	});

	useEffect(() => {
		const handleResize = () => {
			setState({
				isMobile: window.innerWidth < 768,
				isMobilePortrait: window.innerWidth < 768 && window.innerHeight > window.innerWidth,
				isMobileLandscape: window.innerWidth < 768 && window.innerWidth > window.innerHeight,
				isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
				isTabletPortrait:
					window.innerWidth >= 768 && window.innerWidth < 1024 && window.innerHeight > window.innerWidth,
				isTabletLandscape:
					window.innerWidth >= 768 && window.innerWidth < 1024 && window.innerWidth > window.innerHeight,
				isDesktop: window.innerWidth >= 1024,
				isPortrait: window.innerHeight > window.innerWidth,
				isLandscape: window.innerWidth > window.innerHeight,
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('orientationchange', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('orientationchange', handleResize);
		};
	}, []);

	return state;
}
